import { render, staticRenderFns } from "./CaseInformationBody.vue?vue&type=template&id=f04f1dbe"
import script from "./CaseInformationBody.vue?vue&type=script&lang=js"
export * from "./CaseInformationBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports